import Image from "../img/ekip_header2.jpg";
import SectionHeader from "./SectionHeader";
import { GiCutDiamond } from "react-icons/gi";
import {  value } from "../data";
import Card from "../UI/Card";

const Values = () => {
    return (
        <div>
            <section className="value">
                <div className="container values__container">
                    <div className="values__left">
                        <div className="values__image">
                            <img src={Image} alt="valeur _Ekip" />
                        </div>
                    </div>

                    <div className="values__right">
                        <SectionHeader icon={<GiCutDiamond />} title="Services" />
                        <p>
                            Quelle que soit votre vision numérique, notre équipe compétente est là pour vous accompagner à chaque étape du processus, en offrant des solutions créatives et efficaces. Faites confiance à notre expertise pour donner vie à vos projets en ligne !
                        </p>

                        <div className="values__wrapper">
                            {value.map(({ id, icon, desc, title }) => {
                                return (
                                    <Card className="values__value" key={id}>
                                        <span> {icon} </span>
                                        <h4> {title} </h4>
                                        <small> {desc} </small>
                                    </Card>
                                );
                            })}
                        </div>

                    </div>
                </div>
            </section>
        </div>
    );
};

export default Values;
